export default __webpack_public_path__ + "static/section_03_thumb-e96b03e7547740ab71d1782836b5ce87.png";